import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import {
  customLog,
  deploymentEnvironment,
  style,
} from "../../variables/Variables";
import { Button, Modal } from "react-bootstrap";
import "../../assets/css/maincss.css";
import NotificationSystem from "react-notification-system";
import ipapi from "ipapi.co";
// import LocalizedStrings from "react-localization";

import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    linkTitle: "Required Custom Plan?",
    contactTitle: "Contact Sales Team",
    namePlaceholder: "Enter your name *",
    emailPlaceholder: "Enter your email address *",
    subjectTitle: "Please fill in details of your required plan below",
    fieldLabel1: "Number of SMARTLOCKS",
    fieldLabel2: "Number of USERS",
    fieldLabel3: "Number of NFC FOBS/TAGS",
    fieldLabel4: "Please provide a brief description of your application/use",
    fieldLabel5: "Please provide details of any other requirements needed",
    sendBtnTitle: "SEND",
    telNo: "Enter your phone number",
  },
  ja: {
    linkTitle: "カスタムプランが必要ですか？",
    contactTitle: "営業チームに連絡する",
    namePlaceholder: "お名前を入力してください *",
    emailPlaceholder: "メールアドレスを入力してください *",
    subjectTitle: "必要なプランの詳細を以下にご記入ください",
    fieldLabel1: "SMARTLOCKの数",
    fieldLabel2: "ユーザーの数",
    fieldLabel3: "NFC FOB/TAGの数",
    fieldLabel4: "アプリケーション/使用の簡単な説明を提供してください",
    fieldLabel5: "必要なその他の要件の詳細を提供してください",
    sendBtnTitle: "送信",
    telNo: "電話番号を入力してください",
  },
  es: {
    linkTitle: "¿Necesita un plan personalizado?",
    contactTitle: "Contactar al Equipo de Ventas",
    namePlaceholder: "Ingresa tu nombre *",
    emailPlaceholder: "Ingresa tu dirección de correo electrónico *",
    subjectTitle:
      "Por favor, complete los detalles de su plan requerido a continuación",
    fieldLabel1: "Número de SMARTLOCKS",
    fieldLabel2: "Número de USUARIOS",
    fieldLabel3: "Número de NFC FOBS/TAGS",
    fieldLabel4: "Proporcione una breve descripción de su aplicación/uso",
    fieldLabel5: "Proporcione detalles de cualquier otro requisito necesario",
    sendBtnTitle: "ENVIAR",
    telNo: "Ingresa tu número de teléfono",
  },
});

export class ContactSaleTeam extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showSalePopup: false,
      userLoggedIn: false,
      userAccountDetails: {},
      inputName: "",
      inputEmail: "",
      // inputSubject: localizationStrings.subjectTitle,
      inputMessage: "",
      inputQuestion1: 0,
      inputQuestion2: 0,
      inputQuestion3: 0,
      inputOtherRequirement: "",
      _notificationSystem: null,
      currentLanguage: "en",
      countryCode: "",
      phoneInput1: "",
    };

    this.salePopupOpen = this.salePopupOpen.bind(this);
    this.salePopupClose = this.salePopupClose.bind(this);
    this.handleNameInput = this.handleNameInput.bind(this);
    this.handleEmailInput = this.handleEmailInput.bind(this);
    this.handleMessageInput = this.handleMessageInput.bind(this);
    this.handleQuestion1 = this.handleQuestion1.bind(this);
    this.handleQuestion2 = this.handleQuestion2.bind(this);
    this.handleQuestion3 = this.handleQuestion3.bind(this);
    this.handleOtherRequirement = this.handleOtherRequirement.bind(this);
    this.handleSendEmail = this.handleSendEmail.bind(this);

    this.handlePhoneInput1 = this.handlePhoneInput1.bind(this);
  }
  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("registeredIndustrialUsersOnPlatform")
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          this.setState({
            userAccountDetails: snapshot.val(),
            userLoggedIn: true,
          });
        });
    }

    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          const lang = snapshot.val() || "en";
          this.setState({ currentLanguage: lang });
        });
    } else {
      // ✅ not logged in: detect by IP (JP -> ja)
      ipapi.location((callback) => {
        const cc = callback?.country_code;
        const lang = cc === "JP" ? "ja" : "en";
        this.setState({ currentLanguage: lang, countryCode: cc || "" });
      });
    }
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });

    this.setState({
      showSalePopup: false,
    });
  }

  salePopupOpen() {
    this.setState({
      showSalePopup: true,
    });
  }
  salePopupClose() {
    this.setState({
      showSalePopup: false,
    });
  }

  handleNameInput(input) {
    if (input.target.value !== "") {
      this.setState({
        inputName: input.target.value,
      });
    }
  }

  handleEmailInput(input) {
    if (input.target.value !== "") {
      this.setState({
        inputEmail: input.target.value,
      });
    }
  }

  handleMessageInput(input) {
    if (input.target.value !== "") {
      this.setState({
        inputMessage: input.target.value,
      });
    }
  }

  handleQuestion1(input) {
    if (input.target.value !== "") {
      this.setState({
        inputQuestion1: input.target.value,
      });
    }
  }

  handleQuestion2(input) {
    if (input.target.value !== "") {
      this.setState({
        inputQuestion2: input.target.value,
      });
    }
  }

  handleQuestion3(input) {
    if (input.target.value !== "") {
      this.setState({
        inputQuestion3: input.target.value,
      });
    }
  }

  handlePhoneInput1(input) {
    if (input.target.value !== "") {
      this.setState({
        phoneInput1: input.target.value,
      });
    }
  }

  handleOtherRequirement(input) {
    if (input.target.value !== "") {
      this.setState({
        inputOtherRequirement: input.target.value,
      });
    }
  }

  async handleSendEmail(e) {
    e.preventDefault();

    let DataToSend = {};
    let existingAccountUid = "No IAM Account";

    try {
      const currentUser = auth.currentUser;

      // ✅ If user is authenticated
      if (currentUser && currentUser.email && currentUser.uid) {
        const userDetailsSnapshot = await fire
          .database()
          .ref("registeredIndustrialUsersOnPlatform")
          .child(currentUser.uid)
          .once("value");

        const userDetails = userDetailsSnapshot.val();

        DataToSend = {
          deploymentEnvironment,
          supportType: "The Sales Team",
          name: userDetails?.name || "N/A",
          email: currentUser.email,
          phoneNo: this.state.phoneInput1,
          subject: "Required Custom Plan",
          message: this.state.inputMessage,
          userExist: currentUser.uid,
          numberLock: this.state.inputQuestion1,
          numberUsers: this.state.inputQuestion2,
          numberTag: this.state.inputQuestion3,
          otherRequirement: this.state.inputOtherRequirement,
        };
      } else {
        // ✅ For unauthenticated users — basic validation
        if (!this.state.inputName.trim() || !this.state.inputEmail.trim()) {
          this.showNotification("Name and Email are required.", "warning", 4);
          return;
        }

        DataToSend = {
          deploymentEnvironment,
          supportType: "The Sales Team",
          name: this.state.inputName.trim(),
          email: this.state.inputEmail.trim(),
          phoneNo: this.state.phoneInput1,
          subject: "Required Custom Plan",
          message: this.state.inputMessage,
          userExist: existingAccountUid,
          numberLock: this.state.inputQuestion1,
          numberUsers: this.state.inputQuestion2,
          numberTag: this.state.inputQuestion3,
          otherRequirement: this.state.inputOtherRequirement,
        };
      }

      // ✅ Send POST request
      const response = await fetch(
        "https://us-central1-egeetouchindustrial.cloudfunctions.net/contactUs",
        {
          method: "POST",
          headers: {
            "Content-Type": "text/plain", // <-- change Content-Type to text/plain
          },
          body: JSON.stringify(DataToSend), // send as string
        }
      );

      // ✅ Check status before parsing JSON
      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }

      const returnedVal = await response.json();
      customLog("Response:", returnedVal);

      this.showNotification("Message sent!", "success", 3);
      this.setState({ showSalePopup: false }); // Optionally close the modal
    } catch (err) {
      customLog("Send error:", err);
      this.showNotification(
        "Something went wrong! Please try again.",
        "error",
        3
      );
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    localizationStrings.setLanguage(this.state.currentLanguage || "en");

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Modal show={this.state.showSalePopup} onHide={this.salePopupClose}>
          <Modal.Header
            style={{ backgroundColor: "#369af6", color: "white" }}
            closeButton
          >
            <Modal.Title style={{ textAlign: "center" }}>
              {localizationStrings.contactTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSendEmail}>
              {this.state.userLoggedIn ? (
                <input
                  style={{ backgroundColor: "lightgrey" }}
                  className="contactInput"
                  placeholder={this.state.userAccountDetails.name}
                  disabled
                />
              ) : (
                <input
                  className="contactInput"
                  placeholder={localizationStrings.namePlaceholder}
                  onChange={this.handleNameInput}
                  type="text"
                  required
                />
              )}
              {this.state.userLoggedIn ? (
                <input
                  style={{ backgroundColor: "lightgrey" }}
                  className="contactInput"
                  placeholder={auth.currentUser.email}
                  disabled
                />
              ) : (
                <input
                  className="contactInput"
                  placeholder={localizationStrings.emailPlaceholder}
                  onChange={this.handleEmailInput}
                  type="email"
                  required
                />
              )}
              {/* PHONE NUMBER LABEL */}
              <input
                id="phoneNo"
                className="contactInput"
                placeholder={localizationStrings.telNo}
                onChange={this.handlePhoneInput1}
                type="text"
              />

              <input
                style={{ backgroundColor: "lightgrey", border: "none" }}
                className="contactInput"
                // placeholder={this.state.inputSubject}
                placeholder={localizationStrings.subjectTitle}
                disabled
              />

              {/* <input
                id="countryCode"
                className="telNo2"
                onChange={this.handlePhoneInput2}
                type="number"
                required
              /> */}
              {/* PHONE NUMBER LABEL */}

              <label className="contactLabel">
                {localizationStrings.fieldLabel1}
                <div style={{ width: "250px" }}></div>
              </label>
              <input
                id="numberLock"
                className="contactInputNumber"
                onChange={this.handleQuestion1}
                type="number"
                required
                min="1"
              />

              <label className="contactLabel">
                {localizationStrings.fieldLabel2}
              </label>
              <input
                id="numberUser"
                className="contactInputNumber"
                onChange={this.handleQuestion2}
                type="number"
                required
                min="1"
              />

              <label className="contactLabel">
                {localizationStrings.fieldLabel3}
              </label>
              <input
                id="numberTag"
                className="contactInputNumber"
                onChange={this.handleQuestion3}
                type="number"
                required
                min="1"
              />

              <textarea
                className="contactTextArea"
                style={{
                  marginTop: "20px",
                  border: "1px solid #000",
                  resize: "none",
                }}
                placeholder={localizationStrings.fieldLabel4}
                onChange={this.handleMessageInput}
                required
              />

              <input
                className="contactInput"
                placeholder={localizationStrings.fieldLabel5}
                onChange={this.handleOtherRequirement}
                type="text"
              />

              <Button
                style={{ backgroundColor: "#369af6", color: "white" }}
                // onClick={this.handleSendEmail}
                type="submit"
              >
                {localizationStrings.sendBtnTitle}
              </Button>
            </form>
          </Modal.Body>
        </Modal>
        {/* <a href="#" onClick={this.salePopupOpen}>
          <u>Required Custom Plan?</u>
        </a> */}
        <span className="fake-link" onClick={this.salePopupOpen}>
          {localizationStrings.linkTitle}
        </span>
      </div>
    );
  }
}

export default ContactSaleTeam;
